import React, { useEffect, useState } from "react";
import { Box, Button, Flex, Group, Select, Switch, Text, TextInput } from "@mantine/core";
import { getListApplication } from "../../../services/application";
import { validation } from "../../../plugins/validation";
import { notificationError, notificationSuccess } from "../../ui/Notification";
import { addSettingItem, updateSettingItem } from "../../../services/settingItem";
import FormSkeleton from "../../ui/FormSkeleton";

const defaultVal = {
  name: "",
  defaultValue: "",
  isActive: false,
  applicationId: [],
};

const formValidation = {
  name: {
    isError: false,
    message: "",
  },
  defaultValue: {
    isError: false,
    message: "",
  },
  isActive: {
    isError: false,
    message: "",
  },
  applicationId: {
    isError: false,
    message: "",
  },
};

const FormSettingItem = ({ dataSettingItem, onCloseModal, reloadList }) => {
  const [loadingForm, setLoadingForm] = useState(false);
  const [formData, setFormData] = useState(defaultVal);
  const [validationForm, setValidationForm] = useState(formValidation);
  const [selectedApplicationId, setSelectedApplicationId] = useState([]);
  const [applicationList, setApplicationList] = useState([]);

  const handleGetListApplication = async () => {
    setLoadingForm(true);
    try {
      const response = await getListApplication();
      const dataApplication = response.data;
      const mappingApplication = dataApplication.map((val) => {
        return {
          value: val?.id?.toString(),
          label: val?.name,
        };
      });
      setApplicationList(mappingApplication);
    } catch (error) {
      console.log(error);
    }
    setLoadingForm(false);
  };

  useEffect(() => {
    handleGetListApplication();
    if (dataSettingItem !== null) {
      handleSetForm(dataSettingItem);
    }
    // eslint-disable-next-line
  }, [dataSettingItem]);

  const handleSetForm = (dataSettingItem) => {
    const dataDetail = {
      name: dataSettingItem?.name,
      defaultValue: dataSettingItem?.defaultValue,
      isActive: Boolean(dataSettingItem?.isActive),
      applicationId: selectedApplicationId,
    };
    setSelectedApplicationId(dataSettingItem?.application?.id);
    setFormData(dataDetail);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSwitch = () => {
    setFormData({ ...formData, isActive: !formData.isActive });
  };

  const handleSubmit = async (data) => {
    let methodFunction = null;
    let titleMessageSuccess = "";
    let captionMessageSuccess = "";
    let titleMessageError = "";
    let captionMessageError = "";
    setLoadingForm(true);
    setValidationForm(formValidation);
    const payload = {
      name: data.name,
      defaultValue: data.defaultValue,
      isActive: Boolean(data.isActive),
      applicationId: selectedApplicationId,
    };
    const isError = validation(payload, setValidationForm);
    if (isError) {
      setLoadingForm(false);
      return;
    }
    if (dataSettingItem !== null) {
      methodFunction = updateSettingItem(dataSettingItem?.id, payload);
      titleMessageSuccess = "Update Setting Berhasil";
      captionMessageSuccess = "Anda telah berhasil mengupdate data Setting";
      titleMessageError = "Gagal Mengupdate Setting";
      captionMessageError = "Silahkan cek kembali form anda";
    } else {
      methodFunction = addSettingItem(payload);
      titleMessageSuccess = "Tambah Setting Berhasil";
      captionMessageSuccess = "Anda telah berhasil menambahkan Setting baru";
      titleMessageError = "Gagal Menambahkan Setting";
      captionMessageError = "Silahkan cek kembali form anda";
    }
    try {
      const response = await methodFunction;
      if (response) {
        onCloseModal();
        reloadList();
        notificationSuccess(titleMessageSuccess, captionMessageSuccess);
      }
    } catch (error) {
      const errorMessage = error.response.data.message;
      notificationError(titleMessageError, `${Object.keys(errorMessage) ? errorMessage : captionMessageError}`);
      Object.values(errorMessage).forEach((el) => {
        Object.keys(formValidation).forEach((element) => {
          if (el.includes(element)) {
            setValidationForm((old) => ({
              ...old,
              [element]: {
                ...old?.[element],
                isError: true,
                message: el,
              },
            }));
          }
        });
      });
    } finally {
      setLoadingForm(false);
    }
  };

  return (
    <Box>
      {!loadingForm ? (
        <>
          <Box mb="md">
            <TextInput name="name" value={formData.name} label="Nama Organisasi" placeholder="Masukkan nama organisasi" error={validationForm.name.isError ? `${validationForm.name.message}` : ""} onChange={handleChange} withAsterisk />
          </Box>
          <Box mb="md">
            <TextInput
              name="defaultValue"
              value={formData.defaultValue}
              label="Default Value"
              placeholder="Masukkan defaultValue organisasi"
              error={validationForm.defaultValue.isError ? `${validationForm.defaultValue.message}` : ""}
              onChange={handleChange}
              withAsterisk
            />
          </Box>
          <Box mb="md">
            <Select
              name="applicationId"
              label="Aplikasi"
              placeholder="Pilih satu/lebih aplikasi"
              searchable
              nothingFoundMessage="Aplikasi tidak ditemukan"
              data={applicationList}
              onChange={(e) => setSelectedApplicationId(e)}
              error={validationForm?.applicationId?.isError ? `${validationForm?.applicationId?.message}` : ""}
              value={selectedApplicationId}
              withAsterisk
            />
          </Box>
          <Box mb="md">
            <Flex justify="flex-start">
              <Text fz={14} mx={3} mr={8}>
                Active :{" "}
              </Text>
              <Text fz={14} mx={3} mr={8} c="red">
                {validationForm?.isActive?.isError ? `${validationForm?.isActive?.message}` : ""}
              </Text>
              <Switch onLabel="YES" offLabel="NO" checked={formData.isActive} onChange={handleSwitch} />
            </Flex>
          </Box>
        </>
      ) : (
        <Box>
          <FormSkeleton total={3} />
        </Box>
      )}

      <Box mt={20}>
        <Flex justify="flex-end">
          <Group>
            <Button variant="outline" color="indigo.9" onClick={onCloseModal}>
              Tutup
            </Button>
            <Button loading={loadingForm} variant="filled" color="indigo.9" onClick={() => handleSubmit(formData)}>
              Simpan
            </Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  );
};

export default FormSettingItem;
